<template>
  <v-container fluid class="pt-0">
    <v-row>
      <v-col :cols="isPhoneBool ? 12 : 7">
        <QTextField v-model="editItem.Name" :rules="[requiredRule]"
          :label="$t('servicesystem.common_objects.machine.location') + ' / ' + $t('servicesystem.common_objects.machine.name')"
          :externaledit="isNew || editMode" clearable maxlength="50" class="mb-3" @FocusState="handleFocus">
        </QTextField>
        <QTextField v-model="editItem.Facility" :label="$t('servicesystem.common_objects.machine.facility')"
          maxlength="50" :externaledit="isNew || editMode" clearable class="mb-3" @FocusState="handleFocus">
        </QTextField>
      </v-col>
      <v-col :cols="isPhoneBool ? 12 : 5">
        <QTextField v-model="editItem.SerialNumber" :label="$t('servicesystem.common_objects.machine.serial_number')"
          :externaledit="isNew || editMode" :clearable="!serialNumberRequired" class="mb-3" maxlength="50"
          @FocusState="handleFocus">
        </QTextField>
        <QTextField v-model="editItem.Qrcode" :label="$t('servicesystem.common_objects.machine.qr_code')" maxlength="32"
          :externaledit="isNew || editMode" clearable class="mb-3" @FocusState="handleFocus">
        </QTextField>
      </v-col>
      <v-col v-if="userInfo.FirmId" :cols="isPhoneBool ? 12 : 7" class="pt-0 mt-n3">
        <FirmSelect v-model="editItem.FirmId" :externaledit="isNew || editMode" class="mb-3" @FocusState="handleFocus">
        </FirmSelect>
      </v-col>
    </v-row>

    <v-divider class="mb-3"></v-divider>

    <v-row>
      <v-col cols="4">
        <QTextField type="date" v-model="boughtdate" :label="$t('servicesystem.common_objects.machine.bought')"
          :externaledit="isNew || editMode" clearable @FocusState="handleFocus">
        </QTextField>
      </v-col>
      <v-col cols="4">
        <QTextField type="date" v-model="installationdate" :label="$t('servicesystem.common_objects.machine.installed')"
          :externaledit="isNew || editMode" clearable @FocusState="handleFocus">
        </QTextField>
      </v-col>
      <v-col cols="4">
        <QTextField type="date" v-model="warrantyexpiresdate"
          :label="$t('servicesystem.common_objects.machine.warranty_expires')" :externaledit="isNew || editMode"
          clearable @FocusState="handleFocus">
        </QTextField>
      </v-col>
    </v-row>

    <v-row>
      <v-col v-if="false" cols="12" lg="6">
        <QTextField v-model="editItem.YearlyBudget" :label="$t('servicesystem.common_objects.machine.yearly_budget')"
          :externaledit="isNew || editMode" clearable @FocusState="handleFocus">
        </QTextField>
      </v-col>
      <v-col v-if="false" cols="12" lg="6">
        <QCheckboxInput v-model="editItem.CustomerAgreement"
          :label="$t('servicesystem.common_objects.machine.customer_agreement')" :externaledit="isNew || editMode"
          clearable @FocusState="handleFocus">
        </QCheckboxInput>
      </v-col>
    </v-row>
    <v-row>
      <v-col style="background-color: rgb(243 247 255);" class="pt-2 pb-4">
        <QTextArea v-model="editItem.Note" :label="$t('servicesystem.common_objects.machine.note')"
          :externaledit="isNew || editMode" :timestampOnFirstLineEnter="globalSettings.OnEnterUserTimestampMachineNote"
          clearable backgroundcolor="rgb(243 247 255)" @FocusState="handleFocus">
        </QTextArea>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import FirmSelect from "@/components/Inputs/EntityDropdowns/FirmSelect2.vue";

export default {
  name: "MachineDetailsEditContent",
  props: {
    editItem: Object,
    editMode: Boolean,
    handleFocus: Function,
  },
  components: {
    FirmSelect,
  },
  mixins: [clientAPI],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {},

  computed: {
    warrantyexpiresdate: {
      get() {
        return this.VuetifyFormatDate(this.editItem.WarrantyExpiresDate);
      },
      set(value) {
        this.editItem.WarrantyExpiresDate = value;
      },
    },

    installationdate: {
      get() {
        return this.VuetifyFormatDate(this.editItem.InstallationDate);
      },
      set(value) {
        this.editItem.InstallationDate = value;
      },
    },

    boughtdate: {
      get() {
        return this.VuetifyFormatDate(this.editItem.BoughtDate);
      },
      set(value) {
        this.editItem.BoughtDate = value;
      },
    },

    isNew() {
      return this.editItem?.Id == null || this.editItem?.Id === 0;
    },

    globalSettings() {
      return this.$store.state.GlobalSettings;
    },

    serialNumberRequired() {
      return this.$store.state.GlobalSettings.SerialNumberRequired;
    },
  },

  watch: {},
};
</script>


<style lang='scss'></style>